export class KeyMetricsTable {
  private config: any = {
    rowHeaders: [],
    colHeaders: [],
    data: [],
    columns: [],
    stretchH: 'all',
    readOnly: true,
    height: 300,
    rowHeaderWidth: 250,
    manualRowResize: true,
    manualColumnResize: true
  };

  constructor(rowHeaders: string[],
              colHeaders: string[],
              columns: string[],
              data: any[]) {
    Object.assign(this.config, {rowHeaders, colHeaders, data, columns});
  }

  // ----------------------------------------Row headers-----------------------------------------------------------------
  public addRowHeader(row: string): void {
    this.config.rowHeaders.push(row);
  }

  public set rowHeaders(rows: string[]) {
    this.config.rowHeaders = rows;
  }

  public get rowHeaders(): string[] {
    return this.config.rowHeaders;
  }

  public clearRowHeaders(): void {
    this.config.rowHeaders = [];
  }

  // ----------------------------------------Col headers-----------------------------------------------------------------
  public addColHeader(row: string): void {
    this.config.colHeaders.push(row);
  }

  public set colHeaders(rows: string[]) {
    this.config.colHeaders = rows;
  }

  public get colHeaders(): string[] {
    return this.config.colHeaders;
  }

  public clearColHeaders(): void {
    this.config.colHeaders = [];
  }

  // -----------------------------------------------Data-----------------------------------------------------------------
  public addData(row: string[]): void {
    this.config.data.push(row);
  }

  public set data(rows: any[]) {
    this.config.data = rows;
  }

  public get data(): any[] {
    return this.config.data;
  }

  public clearData(): void {
    this.config.data = [];
  }

  // -----------------------------------------------Columns--------------------------------------------------------------
  public addColumn(row: string): void {
    this.config.columns.push(row);
  }

  public set columns(rows: string[]) {
    this.config.columns = rows;
  }

  public get columns(): string[] {
    return this.config.columns;
  }

  public clearColumns(): void {
    this.config.columns = [];
  }

  // --------------------------------------------------------------------------------------------------------------------
  public get configs(): any {
    return this.config;
  }
}
